export default __webpack_public_path__ + "static/media/spoonful-closure-announcement.aee9d90b.jpg";